import { APP_INITIALIZER, Provider } from '@angular/core';
import { MobileAppLifecycleService } from '../../services/mobile-app-lifecycle.service';
import { isFromMobileApp } from '@app/core/helpers';

export function mobileLifecycleInitFactory(
  lifecycle: MobileAppLifecycleService,
) {
  return () => {
    if (!isFromMobileApp()) return Promise.resolve();
    return lifecycle.init();
  };
}

export const MOBILE_LIFECYCLE_INIT_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: mobileLifecycleInitFactory,
  deps: [MobileAppLifecycleService],
  multi: true,
};
